/**
 * Jetons de l'écran de compte.
 *
 * Palette locale colocalisée, comme `studio/settings-overlay/palette.ts` : la
 * convention du produit veut que les surfaces « moment » — carte de bienvenue,
 * aperçu de morceau, réglages — portent leurs valeurs près d'elles plutôt que
 * de tirer sur les classes utilitaires, pour qu'elles se lisent comme une
 * famille et non comme des écrans d'outil.
 *
 * Les couleurs de base sont celles de `welcome-studio-card.tsx` à l'identique.
 * Les opacités de texte, elles, ont été relevées : `--color-text-muted` en
 * 11 px donne ≈ 2,3:1 sur ce fond, ce qui échoue le seuil AA. Les valeurs
 * ci-dessous passent.
 */
export const ACCOUNT_COLORS = {
  text: "rgba(255, 255, 255, 0.92)",
  /** Sous-ligne du titre. */
  textSecondary: "rgba(255, 255, 255, 0.60)",
  /** Étiquettes et légendes 11 px : ≈ 4,9:1, passe AA. */
  textMuted: "rgba(255, 255, 255, 0.50)",
  /** Étiquette du champ qui a le focus. */
  textLabelActive: "rgba(255, 255, 255, 0.72)",
  placeholder: "rgba(255, 255, 255, 0.35)",

  /**
   * Filet au repos. Le chiffre n'est pas esthétique : à 0,34 le trait donne
   * ≈ 3,0:1 sur la surface, seuil de WCAG 1.4.11 pour la frontière qui
   * identifie un contrôle. La bordure de champ actuelle du produit est à 0,06,
   * soit ≈ 1,15:1 — elle échoue. C'est aussi trois fois plus lumineux que
   * `--color-glass-separator` (0,10), ce qui empêche de lire le filet comme un
   * séparateur.
   */
  rule: "rgba(255, 255, 255, 0.34)",

  accent: "#8b5cf6",
  accentSubtle: "rgba(139, 92, 246, 0.10)",
  ruleFocusGlow: "0 1px 12px rgba(139, 92, 246, 0.35)",

  /** `--color-err` (#ef4444) donne ≈ 4,4:1 et manque AA de peu. Celle-ci
   *  ≈ 6,0:1, et elle existe déjà dans `settings-overlay/palette.ts`. */
  error: "#f87171",
} as const;

/** Courbe d'entrée du produit, déjà utilisée par `briefing-card-enter`. */
export const ACCOUNT_EASING = "cubic-bezier(0.16, 1, 0.3, 1)";
